<template>
    <div class="terms">
        <div class="card">
			<div class="card__header">
				<h4 class="card__title">KYC Policy</h4>
			</div>
                        When a user makes an aggregate lifetime total of deposits exceeding EUR 2000 or requests a withdrawal of any amount inside the {{ $root.$company.name }}, then it is compulsory for them to perform a full KYC process.
    <br /><br />
    During this process, the user will have to input some basic details about themselves and then upload
    <br /><br />
    1. A copy of Government Issued Photo ID (in some cases front and back depending on the doc)<br />
    2. A selfie of themselves holding the ID doc<br />
    3. A bank statement/Utility Bill<br />
    <br />
    Once uploaded, the user will get a “Temporarily Approved” Status and the documents will now be on our side, and the “KYC Team” will have 24hrs to go over them and email the user about the outcome:<br />
    - Approval<br />
    - Rejection<br />
    - More information needed – No change in Status<br />
    <br />
    When the user is on “Temporarily Approved” Status then:<br />
    - They can use the platform normally<br />
    - They cannot deposit more than EUR 500 in aggregate total<br />
    - They cannot complete any withdrawal.<br />

    <h5>Guideline for the "KYC Process"</h5>
    1. Proof of ID<br />
    a. Signature Is there<br />
    b. Country is not a Restricted Country: <br />
    - United States of America and its territories;<br />
    - France and its territories; <br />
    - Netherlands and its territories and countries that form the Kingdom of Netherlands including Bonaire, Sint Eustatius, Saba, Aruba, Curacao and Sint Maarten; <br />
    - Australia and its territories; <br />
    - United Kingdom of Great Britain; <br />
    - Northern Ireland; <br />
    - Spain; <br />
    - Austria; <br />
    - Cyprus.<br />
    c. Full Name matches client’s name<br />
    d. Document does not expire in the next 3 months<br />
    e. Owner is over 18 years of age<br />
    <br />
    2. Proof of Residence<br />
    a. Bank Statement or Utility Bill<br />
    b. Country is not a Restricted Country: <br />
    - United States of America and its territories;<br />
    - France and its territories; <br />
    - Netherlands and its territories and countries that form the Kingdom of Netherlands including Bonaire, Sint Eustatius, Saba, Aruba, Curacao and Sint Maarten; <br />
    - Australia and its territories; <br />
    - United Kingdom of Great Britain; <br />
    - Northern Ireland; <br />
    - Spain; <br />
    - Austria; <br />
    - Cyprus.<br />
    c. Full Name matches client’s name and is same as in proof of ID.<br />
    d. Date of Issue: In the last 3 months<br />
    <br />
    3. Selfie with ID<br />
    a. Holder is the same as in the ID document above<br />
    b. ID document is the same as in “1”. Make sure photo/ID number is the same<br />

    <h5>Notes on the "KYC Process"</h5>
    1. When the KYC process is unsuccessful then the reason is documented and a support ticket is created in the system. The ticket number along with an explanation is communicated back to the user.<br />
    2. Once all proper documents are in our possession then the account gets approved.<br />

    <h5>Other AML measures</h5>
    1. If a user has not passed full KYC then they cannot make additional deposits or withdrawals of any amount.<br />
    2. If a user has passed the KYC process successfully then<br />
    a. There is a deposit limit per transaction (max EUR 2,000)<br />
    b. Prior to any withdrawal there is a detailed algorithmic and manual check on the activity and balance of the user to see if the amount withdrawn is a result of proper activity in the platform.<br />
    <br />
    3. Under no circumstances may a user transfer funds directly to another user.
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>